import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  font: ${props => props.theme.fontWeightHeavy} 14px/120% ${props => props.theme.fontFamilyBody};
  margin: 10px 0;
  padding: 5px 10px;
  border-bottom: 1px solid ${props => props.theme.primaryColor};

  & > .category {
    min-width: 280px;
    margin-right: 20px;
  }

  & > .question {
    flex-grow: 2;
  }

  & > .types {
    flex-grow: 1;
    text-align: right;
  }

`;

export default function Header() {
  return (
    <Container>
      <span className="category">Category</span>
      <span className="question">Question</span>
      <span className="types">Fund Types</span>
    </Container>
  );
}
